import { createAxiosForClient } from '@/lib/axios';
import type { AxiosInstance } from 'axios';

export const useAxios = (clientId: string): AxiosInstance => {
  return createAxiosForClient(clientId);
};
